import DestinationListPage from '../src/pages/DestinationListPage';

export default DestinationListPage;
